const CartSummary = function () {
    const checkoutLegalModalSelector = '[data-remodal-id=modal-checkout-legal]';
    const checkoutPreAuthModalSelector = '[data-remodal-id=modal-checkout-preauth]';
    const checkoutRightColumnSelector = '.checkoutRight';
    const instantRedeemTutorialCookieName = 'INSTANT_REDEEM_COOKIE_TUTORIAL';
    const instantRedeemTutorialCookieDurationDays = 365;
    const instacartOtherAmountValue = '-1';
    let cartSummary = {};

    //****************************************************************
    // Init
    //****************************************************************
    const _init = function () {
        _manageStickySummarySize();
    };

    //****************************************************************
    // Ajax update
    //****************************************************************

    const _updateCartSummary = function (tipAppliedSuccess) {
        var summary = $(checkoutRightColumnSelector);
        TINK.inProgress(summary);

        var forceUseLatestPrice = !$.isEmptyObject(cartSummary) && !$.isEmptyObject(cartSummary.priceLines);
        if (forceUseLatestPrice) {
            forceUseLatestPrice = false;
            cartSummary.priceLines.forEach(function (priceLine) {
                if (priceLine.priceType === 'TAX') {
                    forceUseLatestPrice = true;
                }
            });
        }

        var pageCheckoutStep; // 0 is cart
        if (typeof checkoutStep !== 'undefined') {
            pageCheckoutStep = checkoutStep;
        } else {
            pageCheckoutStep = $('.checkoutStepActive').last().data('checkout-step');
        }

        let uPassAisleSubTotal;
        if (typeof uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            uPassAisleSubTotal = uPass.getCartUPassAisleSubTotal(uPassAisleId);
        }

        let itemData = {
            checkoutStep: pageCheckoutStep,
            forceUseLatestPrice: forceUseLatestPrice,
            uPassAisleSubTotal: uPassAisleSubTotal,
            tipAppliedSuccess: typeof tipAppliedSuccess !== 'undefined' && tipAppliedSuccess
        };

        $.ajax({
            url: cartSummaryUrl,
            type: 'GET',
            data: itemData,
            headers: {
                'Accept-Language': lang
            },
            success: function (updatedCartSummary) {
                if (updatedCartSummary != null) {
                    _refreshSummaryHtml(updatedCartSummary);
                }
                if (typeof Checkout !== 'undefined') {
                    Checkout.bindAndEnableCheckoutButtons();
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    /* Refresh the whole page if we can't update the cart summary */
                    window.location.reload();
                }
            },
            complete: function () {
                TINK.stopProgress(summary);
            }
        });
    };

    //****************************************************************
    // Json to html
    //****************************************************************

    const _refreshSummaryHtml = function (newCartSummary) {
        cartSummary = newCartSummary;
        _createSummaryHtml();
        _refreshCompletedSteps();
        _bindTipping();
        _bindPromoCode();
        _bindLegalTextsModal();
        _bindReorderModal();
        _bindChangeService();
        _pushWebviewEvent();
    };

    const _createSummaryHtml = function () {
        if (!$.isEmptyObject(cartSummary)) {
            let inCheckout = cartSummary.inCheckout;
            let inCart = cartSummary.inCart;
            let inOrderDetails = cartSummary.inOrderDetails;

            let $checkoutRightColumn = $(checkoutRightColumnSelector);
            let $checkoutPreAuthModal = $('#showCheckoutPreAuthTexts');
            let checkoutPreAuthModalHtml = $checkoutPreAuthModal.length ? $checkoutPreAuthModal.prop('outerHTML') : '';

            $checkoutRightColumn.empty();

            let $summaryMainDiv = $('<div/>', {'class': 'review-wrapper'});
            let $summaryTitle = $('<h3/>', {'tabindex': '0'}).append(cartSummary.cartSummaryTitleText);
            let $summaryContent = $('<div/>', {'class': 'review__cart-summary'});

            if (!$.isEmptyObject(cartSummary.priceLines)) {
                cartSummary.priceLines.forEach(function (priceLine) {
                    $summaryContent.append(_createAmountRow(priceLine));
                });
            }

            if (cartSummary.ecoFeePriceLine != null) {
                $summaryContent.append(_createAmountRow(cartSummary.ecoFeePriceLine));
            }

            $summaryContent.append(_createInstacartTipping());
            $summaryContent.append(_createAppliedPromoCodeSection());
            $summaryContent.append(_createAppliedRewardSection());
            $summaryContent.append(_createAddPromoCodeSection());

            // Instant Redeem
            if (inCheckout && cartSummary.instantRedeemDisplayed) {
                if (cartSummary.instantRedeemEnabled) {
                    if (parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) > 0) {
                        $summaryContent.append(_createInstantRedeem(cartSummary.instantRedeemAmountAppliedFormattedValue, cartSummary.redeemableAmountFormattedValue));
                    } else if (cartSummary.instantRedeemMinimumExceeded) {
                        $summaryContent.append(_createInstantRedeem(cartSummary.redeemableAmountFormattedValue, cartSummary.redeemableAmountFormattedValue));
                    } else {
                        $summaryContent.append(_createInstantRedeemNotEnough());
                    }
                } else {
                    // Disabled but shown
                    $summaryContent.append(_createDisabledInstantRedeem());
                }
            }

            if (cartSummary.totalPriceLine != null) {
                $summaryContent.append(_createAmountRow(cartSummary.totalPriceLine));
            }

            let $totalLine = $('<div/>', {'class': 'summary__amount amount--total', 'tabindex': '0'});
            $totalLine.append($('<div/>').append($('<span/>').append(cartSummary.bigTotalPriceLine.description)));
            $totalLine.append($('<div/>').append($('<span/>', {'class': 'cartSummaryTotalWithTax'}).append(cartSummary.bigTotalPriceLine.formattedPrice)));
            $totalLine.append($('<div/>', {'class': inOrderDetails ? 'w-100 amount__note text-align-left' : 'w-100 amount__note'}).append($('<span/>').append(cartSummary.legalMentionText)));
            $summaryContent.append($totalLine);

            if (inCheckout && cartSummary.bigTotalPreAuthPriceLine !== undefined && cartSummary.bigTotalPreAuthPriceLine !== null) {
                let $totalPreAuthLine = $('<div/>', {'class': 'summary__amount amount--total pre-auth--line', 'tabindex': '0'});
                $totalPreAuthLine.append($('<div/>').append($('<span/>').append(cartSummary.bigTotalPreAuthPriceLine.description)));
                $totalPreAuthLine.append($('<div/>').append($('<span/>', {'class': 'cartSummaryBigTotalPreAuth'}).append(cartSummary.bigTotalPreAuthPriceLine.formattedPrice)));
                $summaryContent.append($totalPreAuthLine, checkoutPreAuthModalHtml);
            }

            let $loyaltyTextContainer = cartSummary.showLoyaltyPoints ? $('<p>', {'class': 'review__loyalty--earning color-moi-purple', 'tabindex': '0'}).append(cartSummary.loyaltyCardText) : '';

            $summaryMainDiv.append($summaryTitle, $summaryContent, $loyaltyTextContainer);
            $summaryMainDiv.append(_createReorderSection());

            $checkoutRightColumn.append($summaryMainDiv);

            if (inCheckout) {

                let $placeOrderBtn = $('<button/>', {
                    'class': 'cta-primary medium w-100 checkout-button checkoutButtonsPlaceOrder',
                    'type': 'button'
                });
                $placeOrderBtn.append($('<span/>', {'class': 'mr-1 mr-xl-0'}).append(cartSummary.placeOrderBtnText));
                $placeOrderBtn.append($('<span/>', {'class': 'mobile-tablet-only'}).append(cartSummary.bigTotalPriceLine.formattedPrice));

                if (checkoutStep !== 4) {
                    $placeOrderBtn.prop('disabled', true);
                }
                $checkoutRightColumn.append($placeOrderBtn);
            } else if (inCart) {
                let $continueShoppingContainer = $('<div/>').append($('<a/>', {
                    'class': 'cta-secondary medium w-100 continue-shopping-btn',
                    'href': cartSummary.continueShoppingBtnUrl
                }).append(cartSummary.continueShoppingBtnText));

                // Btn for mobile & desktop
                let $checkoutBtnsWrapper = $('<div/>', {'class': 'checkout-buttons'});
                let $checkoutBtnContainer = $('<div/>', {'class': 'cs--checkout'});
                let $checkoutBtn = $('<button/>', {'class': 'cta-primary medium checkout-button', 'type': 'button', 'data-checkout-button': 'all'}).append(cartSummary.cartBtnText);
                if (!cartSummary.minimumOrderAmountExceeded) {
                    $checkoutBtn.prop('disabled', true);
                }
                $checkoutBtnContainer.append($checkoutBtn);
                _updateCartCheckoutReadyCondition($checkoutBtnContainer, $checkoutBtn);
                _updateCartCheckoutUPassWarning($checkoutBtn, cartSummary);
                $checkoutBtnsWrapper.append($checkoutBtnContainer, $continueShoppingContainer);

                // Mobile sticky btn
                let $mobileStickySummaryPlaceOrder = $('<div/>', {
                    'id': 'stickySummary',
                    'class': 'cart-summary--sticky-mobile',
                    'data-checkout-step': '0'
                });

                let $stickySummaryWrapper = $('<div/>', {'class': 'cart-summary--sm--wrapper'});
                let $linkToSummary = $('<a/>', {'href': '', 'class': 'cs--estimated-total focusOnMyAnchor stickySummaryGrandTotal'});
                $linkToSummary.append($('<span/>', {'class': 'cs--text'}).append(cartSummary.bigTotalPriceLine.description));
                $linkToSummary.append($('<span/>', {'class': 'cs--number'}).append(cartSummary.bigTotalPriceLine.formattedPrice));

                $stickySummaryWrapper.append($linkToSummary, $checkoutBtnsWrapper.clone());
                $mobileStickySummaryPlaceOrder.append($stickySummaryWrapper);

                // Desktop btns
                let $desktopPlaceOrderContainer = $('<div/>', {
                    'class': 'summary-sticky sticky-state-trigger except-mobile',
                    'id': 'cart-summary-order-buttons-sticky',
                    'data-cart-summary-reload-order-buttons': true,
                    'data-module': 'stickyState--ie',
                    'data-container': '.summary-wrapper',
                    'data-height-watcher': '.cart--my-basket > .row'
                });

                $desktopPlaceOrderContainer.append($checkoutBtnsWrapper.clone());
                $checkoutRightColumn.append($mobileStickySummaryPlaceOrder, $desktopPlaceOrderContainer);
            }
            TINK.stopProgress($checkoutRightColumn);
            instantRedeemControl(cartSummary);
        }
    };

    const _createAmountRow = function (priceLine) {
        let $amountTextContainer = $('<div/>');
        let bold = priceLine.mainPrice;
        let $amountRow = $('<div/>', {'class': 'summary__amount', 'tabindex': '0'});
        let $textSpan = $('<span/>', {'class': bold ? 'cart-subtotal' : ''}).append(priceLine.description);
        $amountTextContainer.append($textSpan);

        let $amountPriceContainer = $('<div/>');
        let $priceSpan = $('<span/>', {'class': bold ? 'cart-subtotal' : ''}).append(priceLine.formattedPrice);
        $amountPriceContainer.append($priceSpan);

        $amountRow.append($amountTextContainer, $amountPriceContainer);
        return $amountRow;
    };

    const _createInstacartTipping = function () {
        if (!cartSummary.tippingApplicable) {
            return '';
        }

        //MAIN CONTAINER
        let $instacartTippingContainer = $('<div/>', {'id':'tipping-section','class': cartSummary.tipAppliedSuccess ? 'tipping-container valid-other-tip-submit' : 'tipping-container'});

        //TITLE WITH INFO MODAL
        let $tippingTitle = $('<span/>', {'class': 'roboto-bold color-black', 'tabindex': '0'}).append(cartSummary.tipSectionText);
        let $tippingInfoContainer = $('<div/>', {'class': 'tipping-info'});
        let $tippingInfoBtn = $('<span/>', {'class': 'tooltip', 'tabindex': '0','aria-description': cartSummary.tipTooltipText}).append('i');
        let $tippingInfoModal = $('<class/>', {'class': 'tooltip-modal'});
        let $tippingInfoModalText = $('<span/>', {'class': 'tooltip-modal-text'}).append(cartSummary.tipTooltipText);
        let $tippingModalContainer = $('<div/>', {'id': 'tooltipSection', 'class': 'tooltip-container' });
        let $appliedTippingPriceLine = cartSummary.tipPriceLine ? _createAmountRow(cartSummary.tipPriceLine) : '';
        $tippingInfoContainer.append($tippingTitle, $tippingModalContainer);
        $tippingModalContainer.append($tippingInfoBtn, $tippingInfoModal);
        $tippingInfoModal.append($tippingInfoModalText);
        $instacartTippingContainer.append($tippingInfoContainer, $appliedTippingPriceLine);

        if (cartSummary.tippingSelectionEnabled && !$.isEmptyObject(cartSummary.tipOptions)) {
            let $tippingChoicesContainer = $('<div/>', {'class': !!cartSummary.tipOptions.find(t => t.otherAmount).selected ? 'tipping-inputs-container other-amount-checked' : 'tipping-inputs-container'});
            let $tippingChoicesHead = $('<div/>', {'class': 'radio--standard'});

            cartSummary.tipOptions.forEach(function (tipOption, i) {
                let tippingOptionId = 'tippingOption' + i;
                let $tippingRadioLabel = $('<label/>', {'for': tippingOptionId, 'tabindex': '0'});
                let $tippingRadioInput = $('<input/>', {'type': 'radio', 'id': tippingOptionId, 'name': 'tippingOption', 'value': tipOption.value, 'checked': tipOption.selected});
                let $tippingRadioVisual = $('<span/>', {'class': 'radio--box'});
                let $tippingRadioText = $('<span/>', {'class': 'radio--label roboto-bold color-black'}).append(tipOption.formattedValue);

                if (tipOption.otherAmount) {
                    let $toggleOtherAmount = $('<button/>', {'type':'button', 'class': 'toggle-other-amount'}).append(tipOption.toggleText);
                    $tippingChoicesHead.append($toggleOtherAmount);
                    let $tippingOtherAmountContainer = $('<div/>', {'class': 'tipping-other-amount-container', 'id': 'tippingOtherAmountContainer'});
                    let $tippingOtherAmountInputContainer = $('<div/>', {'class': 'tipping-other-amount-input-container', 'id': 'tippingOtherAmountContainer'});
                    let $tippingOtherAmountInput = $('<input/>', {'id': 'tippingOtherAmountInput', 'type': 'text', 'name': 'tippingAmount', 'value': cartSummary.tipAmountFormatted,
                        'onkeyup': 'return CartSummary.manageTippingKeyUpEvent(event);', 'placeholder' : lang === 'en' ? '0.00' : '0,00'});
                    let $tippingOtherAmountButton = $('<button/>', {'id': 'tippingOtherAmountSubmitBtn', 'type': 'button'}).append($('<img/>', {'src': '/magasiner/images/shared/small/icons/arrow-forward-black.svg'}));
                    $tippingRadioLabel.append($tippingRadioInput, $tippingRadioVisual, $tippingRadioText);
                    $tippingOtherAmountInputContainer.append($tippingOtherAmountInput, $tippingOtherAmountButton);
                    $tippingOtherAmountContainer.append($tippingRadioLabel, $tippingOtherAmountInputContainer);
                    $tippingChoicesHead.append($tippingOtherAmountContainer);
                } else {
                    $tippingRadioLabel.append($tippingRadioInput, $tippingRadioVisual, $tippingRadioText);
                    $tippingChoicesHead.append($tippingRadioLabel);
                }
            });

            $tippingChoicesContainer.append($tippingChoicesHead);
            $instacartTippingContainer.append($tippingChoicesContainer);
        }

        return $instacartTippingContainer;
    };

    const _createAppliedPromoCodeSection = function () {
        if (!cartSummary.promoCodeApplicable || !cartSummary.promoCodeApplied) {
            return '';
        }

        let $promoCodeContainer = $('<div/>', {'class': 'os-checkout-input review__add-promo valid--promo appliedPromoCode', 'tabindex': '0'});
        let $appliedPromoCodeTitle = $('<h3/>').append(cartSummary.promoCodeSectionText);
        let $appliedPromoCodeContainer = $('<div/>', {'class': 'applied-promo-code'});
        let $appliedPromoCodeLine = $('<div/>');
        $appliedPromoCodeLine.append($('<span/>').append(cartSummary.promoCode));

        if (!cartSummary.inOrderDetails) {
            $appliedPromoCodeLine.append($('<button/>', {
                'class': 'remove-promo__code',
                'type': 'button',
                'id': 'removeCodePromoButton',
                'data-coupon-id': cartSummary.promoCodeId,
                'aria-label': cartSummary.removePromoCodeBtnText
            }).append($('<img/>', {'src': '/magasiner/images/shared/small/icons/icon-circle-cancel.svg', 'alt': ''})));
        }

        $appliedPromoCodeContainer.append($appliedPromoCodeLine);
        $appliedPromoCodeContainer.append($('<span/>', {'class': 'promo-code-amount'}).append(cartSummary.promoCodeFormattedValue));
        $promoCodeContainer.append($appliedPromoCodeTitle, $appliedPromoCodeContainer);
        return $promoCodeContainer;
    };

    const _createAddPromoCodeSection = function () {
        if (!cartSummary.promoCodeApplicable || cartSummary.promoCodeApplied || cartSummary.inOrderDetails) {
            return '';
        }

        let $promoCodeContainer = $('<div/>', {'class': 'os-checkout-input review__add-promo'});
        let $inputPromoCode = $('<input/>', {'type': 'text', 'id': 'promoCode', 'maxlength': '20', 'onkeyup': 'return CartSummary.managePromoCodeKeyUpEvent(event);'});
        let $buttonApplyPromoCode = $('<button/>', {'class': 'add-promo__apply', 'type': 'button', 'id': 'addCodePromoButton'}).append(cartSummary.applyPromoCodeBtnText);
        let $labelPromoCode = $('<label/>', {'for': 'promoCode'});
        $labelPromoCode.append($('<span/>', {'class': 'promo-add-code'}).append(cartSummary.addPromoCodeBtnText));
        $labelPromoCode.append($('<span/>', {'class': 'promo-enter-code'}).append(cartSummary.labelPromoCodeBtnText));
        $promoCodeContainer.append($inputPromoCode, $labelPromoCode, $buttonApplyPromoCode);
        return $promoCodeContainer;
    };

    const _createInstantRedeem = function (currentAmount, maxAmount) {
        // FILL VARIABLES HERE WITH AJAX RETURN SUCCESS
        let redeemMinAmount = instantRedeemMinimumAmount;
        let redeemMaxAmount = maxAmount;
        let redeemCurrentAmount = TINK.formatCurrency(currentAmount);
        let minAmountText = TINK.formatCurrency(redeemMinAmount);
        let maxAmountText = TINK.formatCurrency(redeemMaxAmount);
        let currentAmountText;
        let redeemToggleText;
        let appliedRedeemText;
        let removeRedeemText;
        let tutoTitle;
        let tutoDescription;
        let tutoClosed;
        let buttonMinusText, buttonPlusText;
        let amountMin = currentAmount * 1 - 1;
        let amountPlus = currentAmount * 1 + 1;

        if (lang == 'en') {
            currentAmountText = 'Apply <span>' + redeemCurrentAmount + '</span>';
            redeemToggleText = 'it\'s time to treat yourself!';
            appliedRedeemText = 'Bravo! Your <span>' + redeemCurrentAmount + '</span> reward has been applied.';
            removeRedeemText = 'Cancel';
            tutoTitle = 'redeeming  points is easy! ';
            tutoDescription = 'Choose the amount you want to redeem and slide the bar accordingly. Then, click the “Apply” button to apply the reward to your purchase.';
            tutoClosed = '<img src="/magasiner/images/shared/small/icons/close--white-bold.svg" alt="Close modal">';
            buttonMinusText = 'Remove 1$ for a total of ' + amountMin;
            buttonPlusText = 'Add 1$ for a total of ' + amountPlus;
        } else {
            currentAmountText = 'Appliquer <span> ' + redeemCurrentAmount + '</span>';
            redeemToggleText = 'c\'est le temps de vous gâter!';
            appliedRedeemText = 'Bravo! Vos <span>' + redeemCurrentAmount + '</span> de récompenses ont été appliqués!';
            removeRedeemText = 'Annuler';
            tutoTitle = 'c\'est facile d\'échanger vos points!';
            tutoDescription = 'Choisissez le montant à échanger et faites glisser la barre. Puis, cliquez sur le bouton "Appliquer mes récompenses" pour l\'appliquer à votre achat.';
            tutoClosed = '<img src="/magasiner/images/shared/small/icons/close--white-bold.svg" alt="Ferme la fenêtre modale contextuelle">';
            buttonMinusText = 'Retirer 1$ pour un total de ' + amountMin;
            buttonPlusText = 'Ajouter 1$ pour un total de ' + amountPlus;
        }

        // SUBMITTED TEXT
        let $redeemSubmitted = $('<div/>', {
            'class': 'applied-redeem'
        }).append(appliedRedeemText);
        $redeemSubmitted.append($('<button/>', {
            'type': 'button',
            'class': 'remove--redeem cta-link'
        }).append(removeRedeemText));

        // MOI ICON
        let $redeemToggleImg = $('<img/>', {
            'class': 'slider-logo',
            'src': "/magasiner/images/shared/small/icons/logo-moi-ellipsis-purple.svg"
        }).append(redeemToggleText);

        // TOGGLE BUTTON
        let $redeemToggleBtn = $('<button/>', {
            'class': 'accordion--btn',
            'data-action': 'toggle-accordion',
            'aria-expanded': 'true'
        }).append(redeemToggleText);

        let $redeemToggleBox = $('<div/>', {
            'class': 'accordion--text',
            'style': 'display:block;'
        });

        // RANGE INPUT
        let $instantRedeemContainer = $('<div/>', {
            'class': 'slider-redeem accordion--standalone active',
            'data-feature': 'accordion-default'
        });

        let $instantRedeemFirstPart = $('<div/>', {
            'class': 'slider-redeem-title'
        });

        let $redeemInput = $('<input/>', {
            'type': 'range',
            'min': redeemMinAmount,
            'max': redeemMaxAmount,
            'value': redeemCurrentAmount,
            'class': 'slider redeemRange',
            'onmousedown': "$('.amount-bubble span').css('display', 'flex');",
            'onmouseup': "$('.amount-bubble span').hide();",
            'tabindex':'1'
        });

        let $visualAmountBubble = $('<div/>', {
            'class': 'amount-bubble',
        }).append($('<span/>').append(redeemCurrentAmount));

        // VISUAL AMOUNT GUIDE
        let $redeemRange = $($('<div/>', {
            'class': 'redeem-range',
            'tabindex':'1'
        }).append($('<span/>', {
            'class': 'min-redeem'
        }).html(minAmountText)).append($('<span/>', {
            'class': 'max-redeem'
        }).html(maxAmountText)));


        // MANUAL AMOUNT CONTROL
        let $redeemBtnControl = $('<div/>', {
            'class': 'redeem-actions'
        });

        let $redeemMinusBtn = $('<button/>', {
            'type': 'button',
            'class': 'btn-change-redeem redeem-minus',
            'aria-label': buttonMinusText
        }).append($('<img>', {'src': '/magasiner/images/shared/icons/icon-minus-white.svg'}));

        let $redeemPlusBtn = $('<button/>', {
            'type': 'button',
            'class': 'btn-change-redeem redeem-plus',
            'aria-label': buttonPlusText
        }).append($('<img>', {'src': '/magasiner/images/shared/icons/icon-plus-white.svg'}));

        let $redeemSubmitBtn = $('<button/>', {
            'type': 'button',
            'class': 'redeem-submit'
        }).append(currentAmountText);

        let $redeemError = $('<span/>', {
            'class': 'error-text'
        });

        let $tutoInstantRedeemSection = '';
        let displayTutorial = !TINK.getCookie(instantRedeemTutorialCookieName) && parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) === 0 && cartSummary.instantRedeemMinimumExceeded;
        if (displayTutorial) {
            $tutoInstantRedeemSection = $('<div>', {'class': 'tuto-redeem-lightbox bg-moi-purple'});
            let $tutoTitle = $('<h2/>', {'class':'color-white'}).append(tutoTitle);
            let $tutoDescription = $('<p/>', {'class':'color-white'}).append(tutoDescription);
            let $tutoClosed = $('<button/>', {'class':'closed-lightbox'}).append(tutoClosed);
            $tutoInstantRedeemSection.append($tutoTitle, $tutoDescription, $tutoClosed);
        }

        $redeemBtnControl.append($redeemMinusBtn, $redeemSubmitBtn, $redeemPlusBtn);
        $redeemToggleBox.append($redeemInput, $redeemRange , $redeemBtnControl, $redeemError, $tutoInstantRedeemSection);
        $instantRedeemFirstPart.append($redeemToggleImg, $redeemToggleBtn);
        $instantRedeemContainer.append($visualAmountBubble, $redeemSubmitted, $instantRedeemFirstPart, $redeemToggleBox);

        //Move the input range to amount value
        $instantRedeemContainer.find('.redeemRange').val(currentAmount);

        return $instantRedeemContainer;
    };

    const _createDisabledInstantRedeem = function () {
        let $errorInstantRedeemSection = $('<div>', {
            'class': 'error-redeem-section bg-moi-purple'
        });

        let errorTitle;
        let errorDescription;
        let phoneNumber;
        let phoneNumberText;

        if (lang == 'en') {
            errorTitle = 'sorry, you can’t redeem your points at the moment.';
            errorDescription = 'Please contact our customer care&nbsp;team&nbsp;at';
            phoneNumber = 'tel:18666380020';
            phoneNumberText = '1-866-595-5554';
        } else {
            errorTitle = 'désolé, vous ne pouvez pas échanger vos points pour l\'instant.';
            errorDescription = 'Veuillez contacter notre service&nbsp;client&nbsp;au';
            phoneNumber = 'tel:18666380020';
            phoneNumberText = '1-866-595-5554';
        }

        let $errorTitle = $('<h3>', {'class': 'color-white'}).append(errorTitle);
        let $errorDescription = $('<p/>', {'class': 'color-white'}).append(errorDescription);
        let $errorPhoneNumber = $('<a/>', {'class': 'color-white', 'href': phoneNumber}).append(phoneNumberText);
        $errorInstantRedeemSection.append($errorTitle, $errorDescription, $errorPhoneNumber);
        return $errorInstantRedeemSection;
    };

    const _createInstantRedeemNotEnough = function () {
        let redeemMinAmount = TINK.formatCurrency(0);
        let redeemMaxAmount = TINK.formatCurrency(instantRedeemMinimumAmount);
        let redeemToggleText;
        let redeemDescriptionText;

        if (lang == 'en') {
            redeemToggleText = 'almost there!';
            redeemDescriptionText = 'Reward yourself as soon as you reach <span class="color-moi-purple">' + instantRedeemMinimumPoints + '&nbsp;points</span>';
        } else {
            redeemToggleText = 'vous y êtes presque!';
            redeemDescriptionText = 'Récompensez vous dès <span class="color-moi-purple">' + instantRedeemMinimumPoints + '&nbsp;points</span>';
        }

        let $redeemDescriptionText = $('<p/>', {
            'class' : 'redeem-text-not-enough'
        }).append(redeemDescriptionText);

        // MOI ICON
        let $redeemToggleImg = $('<img/>', {
            'class': 'slider-logo',
            'src': '/magasiner/images/shared/small/icons/logo-moi-ellipsis-purple.svg'
        }).append(redeemToggleText);

        // TOGGLE BUTTON
        let $redeemToggleBtn = $('<button/>', {
            'class': 'accordion--btn',
            'data-action': 'toggle-accordion',
            'aria-expanded': 'true'
        }).append($redeemToggleImg, redeemToggleText);

        let $redeemToggleBox = $('<div/>', {
            'class': 'accordion--text',
            'style': 'display:block;'
        });

        // RANGE
        let $sliderNotEnough = $('<div/>',{
            'class': 'slider'
        });
        let $instantRedeemNotEnoughContainer = $('<div/>', {
            'class': 'slider-redeem redeem-not-enough accordion--standalone active',
            'data-feature': 'accordion-default'
        });

        // VISUAL AMOUNT GUIDE
        let $redeemRange = $($('<div/>', {
            'class': 'redeem-range'
        }).append($('<span/>', {
            'class': 'min-redeem'
        }).html(redeemMinAmount)).append($('<span/>', {
            'class': 'max-redeem'
        }).html(redeemMaxAmount)));

        $redeemToggleBox.append($sliderNotEnough, $redeemRange, $redeemDescriptionText);
        $instantRedeemNotEnoughContainer.append($redeemToggleBtn, $redeemToggleBox);
        return $instantRedeemNotEnoughContainer;
    };

    const _controlAriaLabel = function (redeemCurrentAmount) {
        let buttonMinusText, buttonPlusText;
        let amountMin = redeemCurrentAmount * 1 - 1;
        let amountPlus = redeemCurrentAmount * 1 + 1;

        if (lang == 'en') {
            buttonMinusText = 'Remove 1$ for a total of ' + amountMin;
            buttonPlusText = 'Add 1$ for a total of ' + amountPlus;
        } else {
            buttonMinusText = 'Retirer 1$ pour un total de ' + amountMin;
            buttonPlusText = 'Ajouter 1$ pour un total de ' + amountPlus;
        }

        $('.redeem-minus').attr('aria-label', buttonMinusText);
        $('.redeem-plus').attr('aria-label', buttonPlusText);
    };

    const instantRedeemControl = function (cartSummary) {
        if (!cartSummary.inCheckout || !cartSummary.instantRedeemDisplayed || !cartSummary.instantRedeemEnabled) {
            return false;
        }

        $('.slider-redeem:not(.accordion-default-is_initialized)').accordion_default();

        if (cartSummary.instantRedeemMinimumExceeded) {
            let $inputRange = $('.redeemRange');
            let inputRangeVal = 0;
            let minInputRange = $inputRange.prop('min');
            let maxInputRange = $inputRange.prop('max');
            let $inputRangeInput;

            // MINUS BTN
            $('.redeem-minus').on('click', function () {
                $inputRangeInput = $(this).parents('.accordion--text').find($inputRange);
                inputRangeVal = $inputRangeInput.prop('value');
                inputRangeVal--;
                $inputRange.prop('value', inputRangeVal);

                $(this).prop('disabled', inputRangeVal === minInputRange);
                $('.redeem-plus').prop('disabled', inputRangeVal === maxInputRange);
                $('.redeem-submit span, .applied-redeem span').html(TINK.formatCurrency(inputRangeVal));
                $('.redeem-submit').attr('data-redeem-amount', inputRangeVal);
                $inputRange.trigger('change');
                _controlAriaLabel(inputRangeVal);
            });

            // PLUS BTN
            $('.redeem-plus').on('click', function () {
                $inputRangeInput = $(this).parents('.accordion--text').find($inputRange);
                inputRangeVal = $inputRangeInput.prop('value');
                inputRangeVal++;
                $inputRange.prop('value', inputRangeVal);

                $(this).prop('disabled', inputRangeVal === maxInputRange);
                $('.redeem-minus').prop('disabled', inputRangeVal === minInputRange);
                $('.redeem-submit span, .applied-redeem span').html(TINK.formatCurrency(inputRangeVal));
                $('.redeem-submit').attr('data-redeem-amount', inputRangeVal);
                $inputRange.trigger('change');
                _controlAriaLabel(inputRangeVal);
            });

            // SUBMIT BTN
            $('.redeem-submit').on('click', function () {
                _addInstantRedeem();
            });

            $('.remove--redeem').on('click', function () {
                _removeInstantRedeem();
            });

            // ON INPUT CHANGE WITH DRAG
            $inputRange.on('input change', function () {
                let newValue = $(this).prop('value');
                $('.redeem-submit span').html(TINK.formatCurrency(newValue));
                if (newValue === minInputRange) {
                    $('.redeem-minus').prop('disabled', true);
                    $('.redeem-plus').prop('disabled', false);
                } else if (newValue === maxInputRange) {
                    $('.redeem-plus').prop('disabled', true);
                    $('.redeem-minus').prop('disabled', false);
                } else {
                    $('.redeem-plus, .redeem-minus').prop('disabled', false);
                }
                $('.applied-redeem span').html(TINK.formatCurrency(newValue));
                $('.redeem-submit').attr('data-redeem-amount', newValue);
                $('.amount-bubble span').attr('data-redeem-amount', newValue).html(TINK.formatCurrency(newValue));
                _controlAriaLabel(newValue);
                let value = (this.value-this.min)/(this.max-this.min)*100-0.1;
                $('.amount-bubble span').css('left', value + '%');
                $(this).css('background', 'linear-gradient(to right, #c131a0 0%, #9606b1 ' + value + '%, #e3e3e3 ' + value + '%, #e3e3e3 100%)');
            });

            // If card has applied instant redeem, we change the view
            if (parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) > 0) {
                $('.redeem-submit').attr('data-redeem-amount', cartSummary.instantRedeemAmountAppliedFormattedValue);
                $('.slider-redeem').addClass('isSubmit');
            } else {
                $('.redeem-submit').attr('data-redeem-amount', cartSummary.redeemableAmountFormattedValue);
                if (cartSummary.redeemableAmountFormattedValue === maxInputRange) {
                    $('.redeem-plus').prop('disabled', true);
                }
            }
        }

        // Instant redeem tutorial
        $('.closed-lightbox, .checkoutButtonsPlaceOrder, .redeem-submit').on('click', function () {
            $('.tuto-redeem-lightbox').fadeOut();
            TINK.setCookie(instantRedeemTutorialCookieName, true, instantRedeemTutorialCookieDurationDays);
        });
    };

    const _createReorderSection = function () {
        if (!cartSummary.displayReorderBtn) {
            return '';
        }

        let $reorderBtn = $('<button/>', {
            'class': 'cta-secondary w-100 debounce-250 reorderOrder order-summary-reorder',
            'type': 'button'
        });
        $reorderBtn.prop('disabled', !cartSummary.reorderAllowed);
        $reorderBtn.append($('<span/>').append(cartSummary.reorderBtnText));

        return $reorderBtn;
    };

    const _createAppliedRewardSection = function () {
        if (!cartSummary.voucherApplicable || $.isEmptyObject(cartSummary.vouchers) || !cartSummary.atLeastOneVoucherApplied) {
            return '';
        }

        let $rewardContainer = $('<div/>', {'class': 'os-checkout-input review__add-promo valid--promo appliedVouchers', 'tabindex': '0'});
        let $appliedRewardTitle = $('<h3/>').append(cartSummary.rewardDescriptionText);
        $rewardContainer.append($appliedRewardTitle);
        if (cartSummary.vouchers != null) {
            cartSummary.vouchers.forEach(function (voucher) {
                if (voucher.applied) {
                    let $appliedRewardContainer = $('<div/>', {'class': 'applied-promo-code'});
                    let $appliedRewardLine = $('<div/>').append($('<span/>').append(voucher.voucherDescription));
                    $appliedRewardContainer.append($appliedRewardLine);
                    $appliedRewardContainer.append($('<span/>', {'class': 'promo-code-amount'}).append(voucher.remainingBalanceFormatted));
                    $rewardContainer.append($appliedRewardContainer);
                }
            });
        }
        return $rewardContainer;
    };

    const _refreshCompletedSteps = function () {
        if (!$.isEmptyObject(cartSummary)) {
            $('.checkoutLoyaltyPoints').html(cartSummary.loyaltyPoints);
            $('.checkoutLoyaltyPointsText').html(cartSummary.loyaltyCardText);
            $('.checkoutTotalWithTax').text(cartSummary.bigTotalPriceLine.formattedPrice);
            $('.checkoutTipAmount').html(cartSummary.tipPriceLine ? cartSummary.tipPriceLine.formattedPrice : '');
        }
    };

    //****************************************************************
    // Express Delivery checkout ready condition
    //****************************************************************

    const _updateCartCheckoutReadyCondition = function ($checkoutBtnContainer, $checkoutBtn) {
        let $miniCartSpontaneousSection = $('.mini-cart-side-panel--spontaneous');
        let maxEntriesCriteria = $miniCartSpontaneousSection.attr('data-max-entries-criteria');

        if (typeof maxEntriesCriteria !== 'undefined') {
            let totalEntries = $miniCartSpontaneousSection.attr('data-total-entries');
            if (typeof totalEntries !== 'undefined') {
                if (parseInt(totalEntries) > parseInt(maxEntriesCriteria)) {
                    // Disable checkout button
                    $checkoutBtn.text(maxItemTotalExceededMessage.replace('{0}', totalEntries).replace('{1}', maxEntriesCriteria));
                    $checkoutBtn.prop('disabled', true);
                    // Define change service button
                    let $changeServiceBtn = $('<button/>', {'class': 'openStoreLocator cs--ed-change-service', 'type': 'button'});
                    $changeServiceBtn.append($('<span/>').append(cartSummary.changeServiceBtnText));
                    $changeServiceBtn.attr('service-and-timeslot-target', serviceUrl);
                    // Add change service button to checkout container
                    $checkoutBtnContainer.append($changeServiceBtn);
                }
            }
        }
    };

    const _bindChangeService = function () {
        let $changeServiceBtn = $('.cs--ed-change-service');
        if ($changeServiceBtn.length) {
            $changeServiceBtn.on('click', function () {
                ServiceTimeslot.openServiceAndTimeslot.bind(this)();
            });
        }
    };

    //****************************************************************
    // UPass
    //****************************************************************

    const _updateCartCheckoutUPassWarning = function ($checkoutBtn, cartSummary) {
        if (!cartSummary.minimumOrderAmountExceeded && typeof uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            let $uPassAisle = $('[data-aisle="' + uPassAisleId + '"]');
            if ($uPassAisle.length) {
                let $msgMetroPassMobile = $('<div/>', {'class': 'minimum-order-amount-warning'});
                if (cartSummary.minimumOrderAmountText !== null) {
                    $msgMetroPassMobile.append('<span>' + cartSummary.minimumOrderAmountText + '</span>');
                    $msgMetroPassMobile.insertBefore($checkoutBtn);
                }
            }
        }
    };

    //****************************************************************
    // Promo code
    //****************************************************************

    const _addPromoCode = function (e) {
        e.preventDefault();
        var promoCode = $('#promoCode').val();
        if (promoCode.trim().length === 0) {
            return;
        }

        _disablePlaceOrder(true);

        var $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        TINK.sessionAjax({
            url: promoCodeAjaxUrl + '/' + promoCode,
            type: 'POST',
            success: function (promoCodeResponse) {
                TINK.stopProgress($container);
                if (promoCodeResponse.promoCodeApplied) {
                    _updateCartSummary();
                    pushDataLayerPromoCodeAddToCart(promoCode);
                } else {
                    var $addPromoCodeContainer = $('.review__add-promo');
                    $addPromoCodeContainer.addClass('has--error');
                    $addPromoCodeContainer.find('label[for=promoCode]').after($('<span>', {'class': 'error--text'}).append(promoCodeResponse.errorMessage));
                    _disablePlaceOrder(checkoutStep !== 4);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _removePromoCode = function (e) {
        e.preventDefault();
        _disablePlaceOrder(true);

        var $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        var promoCode = $(this).attr('data-coupon-id');
        TINK.sessionAjax({
            url: promoCodeAjaxUrl + '/' + promoCode,
            type: 'DELETE',
            success: function () {
                _updateCartSummary();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _bindPromoCode = function () {
        $('#addCodePromoButton').on('click', _addPromoCode);
        $('#removeCodePromoButton').on('click', _removePromoCode);
    };

    const _managePromoCodeKeyUpEvent = function (e) {
        let $addPromoCodeContainer = $('.review__add-promo');
        $addPromoCodeContainer.removeClass('has--error');
        $addPromoCodeContainer.find('.error--text').remove();
        let $target = $(e.target);

        if ($target.val().length >= 1) {
            $target.addClass('minimumValueStyle');
        } else {
            $target.removeClass('minimumValueStyle');
        }

        if (e.which === 13 || e.keyCode === 13) {
            _addPromoCode(e);
            return false;
        }
        return true;
    };

    //****************************************************************
    // Instant Redeem
    //****************************************************************

    const _addInstantRedeem = function () {
        let pointValue = $('.redeem-submit').attr('data-redeem-amount');
        if (pointValue.trim().length === 0) {
            return;
        }

        _disablePlaceOrder(true);

        let $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        $.ajax({
            url: instantRedeemAjaxUrl,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({'pointValue': pointValue}),
            success: function (instantRedeemResponse) {
                TINK.stopProgress($container);

                if (instantRedeemResponse.instantRedeemApplied) {
                    _updateCartSummary(null);
                } else {
                    let $instantRedeemContainer = $('.slider-redeem');
                    $instantRedeemContainer.addClass('has--error');
                    $instantRedeemContainer.find('.error-text').text(instantRedeemResponse.errorMessage);

                    _disablePlaceOrder(checkoutStep !== 4);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _removeInstantRedeem = function () {
        _disablePlaceOrder(true);

        let $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        TINK.sessionAjax({
            url: instantRedeemAjaxUrl,
            type: 'DELETE',
            contentType: 'application/json',
            success: function () {
                _updateCartSummary(null);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    //****************************************************************
    // Tipping
    //****************************************************************

    const _updateCartTip = function (tipAmount, tipPercentage) {
        if (!tipAmount && !tipPercentage) {
            return;
        }
        if (isNaN(tipAmount) || isNaN(tipPercentage)) {
            return;
        }

        _disablePlaceOrder(true);

        let $tippingOtherAmountInputContainer = $('.tipping-other-amount-input-container');
        let $container = $(checkoutRightColumnSelector);

        if ($container.length) {
            TINK.inProgress($container);
        }

        $('.tipping-inputs-container .error--text').remove(); // clear previous errors
        $tippingOtherAmountInputContainer.removeClass('input-error');
        $('#tipping-section').removeClass('valid-other-tip-submit');

        TINK.sessionAjax({
            url: tippingAjaxUrl,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({tipAmount: tipAmount, tipPercentage: tipPercentage}),
            success: function (tipResponse) {
                TINK.stopProgress($container);

                if (tipResponse.tipApplied) {
                    _updateCartSummary(null, true);
                } else {
                    let $tipContainer = $('.tipping-inputs-container');
                    $tipContainer.append($('<div>', {'class': 'error--text color-error-message'}).append(tipResponse.errorMessage));
                    $tippingOtherAmountInputContainer.addClass('input-error');
                    _disablePlaceOrder(checkoutStep !== 4);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _bindTipping = function () {
        $('input[name="tippingOption"]').on('change', function () {
            let $otherAmountContainer = $('#tippingOtherAmountContainer');
            let $tippingInputsContainer = $('.tipping-inputs-container');

            if ($(this).val() === instacartOtherAmountValue) {
                $tippingInputsContainer.addClass('other-amount-checked');
                $('#tippingOtherAmountInput').trigger('focus');
                $otherAmountContainer.prepend($('label.other-amount-label'));
            } else {
                $tippingInputsContainer.removeClass('other-amount-checked');
                let tipPercentage = $(this).val().trim();
                _updateCartTip (null, tipPercentage);
            }
        });

        $('button#tippingOtherAmountSubmitBtn').on('click', function () {
            let tipAmount = TINK.sanitizeNumber($('input#tippingOtherAmountInput').val());
            _updateCartTip(tipAmount, null);
        });

        $('button.toggle-other-amount').on('click', function () {
            $('input[name="tippingOption"]').prop('checked', false);
            $('input[name="tippingOption"][value = ' + instacartOtherAmountValue + ']').prop('checked', true).trigger('change');
        })

        $('#tippingOtherAmountInput').on('change', function () {
            $('.tipping-container').removeClass('valid-other-tip-submit');
            $('.tipping-other-amount-input-container').removeClass('input-error');
        });

        $('input#tippingOtherAmountInput').mask(lang === 'en' ? "000.00" : "000,00", {reverse: true});
    };

    const _manageTippingKeyUpEvent = function (e) {
        if (e.which === 13 || e.keyCode === 13) {
            let tipAmount = TINK.sanitizeNumber($('input#tippingOtherAmountInput').val());
            _updateCartTip(tipAmount, null);
            return false;
        }
        return true;
    };

    //****************************************************************
    // Legal texts
    //****************************************************************

    const _bindLegalTextsModal = function () {
        $('button.showCheckoutLegalTexts').on('click', function () {
            $(checkoutLegalModalSelector).remodal().open();
            if (serviceType === 'home_delivery') {
                $('.modal-checkout-legal-delivery').removeClass('hide');
            } else {
                $('.modal-checkout-legal-pickup').removeClass('hide');
            }
        });
        $('button.showCheckoutPreAuthTexts').on('click', function () {
            _hideHelpToolTip();
        });
        $('button.closeToolTip').on('click', function () {
            _hideHelpToolTip();
        });
    };

    const _hideHelpToolTip = function () {
        if ($('.review__cart-summary #showCheckoutPreAuthTexts').css('display') == 'none') {
            $('.review__cart-summary #showCheckoutPreAuthTexts').css({"display": "block"});
        } else {
            $('.review__cart-summary #showCheckoutPreAuthTexts').css({"display": "none"});
        }
    };

    //****************************************************************
    // Util
    //****************************************************************

    const _disableCheckout = function (disable) {
        jQuery('[data-checkout-button=all]').each(function () {
            jQuery(this).prop('disabled', disable);
        });
    };

    const _disablePlaceOrder = function (disable) {
        var $checkoutButtonPlaceOrder = $('button.checkoutButtonsPlaceOrder');
        if ($checkoutButtonPlaceOrder.length) {
            $checkoutButtonPlaceOrder.prop('disabled', disable);
        }
    };

    const _manageStickySummarySize = function () {
        // Reposition footer-sticky-sac based on the summary height
        const stickySummary = document.getElementById('stickySummary');
        const container = document.querySelector('.footer-container');
        const helpButton = document.getElementById('footer-sticky-sac');

        if (stickySummary === null || container === null || helpButton === null) {
            return false;
        }

        let elementHeight = stickySummary.clientHeight;
        const helpButtonHeightInitial = helpButton.clientHeight;
        const gutter = 20;

        updatePosition(elementHeight);

        new ResizeSensor(stickySummary, function () {
            elementHeight = stickySummary.clientHeight;
            updatePosition(elementHeight);
        });

        function updatePosition(elementHeight) {
            container.setAttribute('style', `padding-bottom:${elementHeight + helpButtonHeightInitial + gutter}px;`);
            helpButton.setAttribute('style', 'bottom: ' + (elementHeight + gutter) + 'px;');
        }
    };

    //****************************************************************
    // Reorder
    //****************************************************************

    const _bindReorderModal = function () {
        let $reorderBtn = $('#cartSummaryContainer').find('.reorderOrder');
        $reorderBtn.on('click', function () {
            if (!$(this).hasClass('dishide-trigger-is_initialized')) {
                $(this).addClass('is_active');
            }
            OrderDetails.reorder($(this));
        });
        injectSVG();
    };

    //****************************************************************
    // Webview mode
    //****************************************************************

    const _pushWebviewEvent = function () {
        if (isInWebview() && !$.isEmptyObject(cartSummary)) {
            sendNewQtyInCartEventToDevice(cartSummary.cartNbItems);
        }
    };

    //****************************************************************
    // Expose
    //****************************************************************

    return {
        bindLegalTextsModal: _bindLegalTextsModal,
        disableCheckout: _disableCheckout,
        disablePlaceOrder: _disablePlaceOrder,
        init: _init,
        managePromoCodeKeyUpEvent: _managePromoCodeKeyUpEvent,
        manageTippingKeyUpEvent: _manageTippingKeyUpEvent,
        refreshSummaryHtml: _refreshSummaryHtml,
        updateCartSummary: _updateCartSummary
    };
}();

$(function () {
    CartSummary.init();
});